// in app there is a respective util: does-string-contain-html.js
export const doesStringContainHtml = (value?: string): boolean => {
  if (!value) {
    return false
  }

  return /<[a-z]+[\s\S]*\/?\s*>/i.test(value)
}
